export default {
  formatDate(dataBaseTime) {
    let t = new Date(dataBaseTime);
    const tf = function (i) { return (i < 10 ? '0' : '') + i }
    return tf(t.getFullYear()) + "-" + tf(t.getMonth() + 1) + "-" + tf(t.getDate())
  }
}
